import React from "react";
import { connect } from "react-redux";
import { noImg } from "vrcore-dashboard/dist/utilities";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import MessageIcon from "@material-ui/icons/Message";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { Add as AddIcon, Send as SendIcon } from "@material-ui/icons";
import AddBoxIcon from "@material-ui/icons/AddBox";
import FormHelperText from "@material-ui/core/FormHelperText";
import moment from "moment";
import styled from "styled-components";

import {
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    Spinner,
    ModalHeader,
} from "reactstrap";

import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";

import {
    Button,
    Typography,
    withStyles,
    MenuItem,
    TextField,
    FormControl,
    Table,
    InputLabel,
    Select,
    TableBody,
    TableHead,
    TableCell,
    TableRow,
} from "@material-ui/core";

import {
    getRegisteredUsers,
    setNewGroup,
    getGroups,
    removeGroup,
    editGroup,
    editGroupImage,
    addMessages,
    getAreas, getDepartments
} from "./actions";
import {
    selectRegisteredUsers,
    selectGroup,
    getRequesting,
    canUpdate,
    canCreate,
    canDelete,
    selectProfile,
} from "./selectors";

import IconButton from "@material-ui/core/IconButton";

const StyledAvatar = styled(Avatar)`
    height: 200px !important;
    width: 200px !important;
    margin: auto !important;
    border: 1px solid black !important;
`;

const styles = () => ({
    addUserModel: {
        width: "60%",
    },
    list: {
        width: "100%",
        marginTop: 15,
        marginBottom: 1,
        borderRadius: 5,
        backgroundColor: "#3f51b5",
    },
    listItem: {
        width: "auto",
        backgroundColor: "white",
        marginLeft: 10,
        marginRight: 10,
        borderRadius: 5,
        marginBottom: 1,
        marginTop: 1,
        padding: 0,
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflowX: "auto",
    },
    form: {
        position: "relative",
        width: "90%",
    },
    MessageList: {
        width: "100%",
        backgroundColor: "#dddddd",
    },
    MessageItem: {
        overflowWrap: "break-word",
        width: "auto",
        margin: 12,
        backgroundColor: "#fff",
        borderRadius: 6,
    },
});
class Messenger extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            setGroupImgBlob: "",
            uploadImageLocal: false,
            uploadPhotoLocal: false,
            page: 0,
            MessageColors: [],
            colorNo: 0,
            rowsPerPage: 50,
            removeUID: false,
            editUID: false,
            newGroupModal: false,
            viewGroupModal: false,
            removeGroupModal: false,
            editGroupModal: false,
            addGroupModal: false,
            new_group: {
                group_name: "",
                users_in_group: [],
                group_image: "",
            },
            messages_in_group: {
                message: "",
                sender: false,
                timestamp: moment().format("DD-MM-YYYY HH:mm:ss"),
                attatched_image_url: null,
            },
            viewMessages: false,
        };

        props.getRegisteredUsers();
        props.getGroups();
        props.getDepartments();
        props.getAreas();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.groups !== this.props.groups && this.state.viewMessages) {
            let { id } = this.state.viewMessages;
            let group = this.props.groups.filter((e) => e.group_id === id)[0];
            this.setState({
                colorsNo: group.users_in_group.length,
            });

            let messageArr = [];

            Object.keys(group.messages_in_group).map((f) => {
                messageArr.push(group.messages_in_group[f]);
                return f;
            });
            let sortedSelectedReports = messageArr.sort((a, b) => {
                a = new moment(a.timestamp, "DD-MM-YYYY hh:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
                b = new moment(b.timestamp, "DD-MM-YYYY hh:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
                return a.diff(b);
            });

            let messages = sortedSelectedReports.reverse();
            this.generateColors(group.users_in_group);
            this.setState({
                viewMessages: {
                    id,
                    messages,
                },
            });
        }
    }
    getNameofUser(uid) {
        const users = this.props.users === [] ? false : this.props.users;

        for (let i = 0; i < users.length; i++) {
            if (users[i].uid === uid) {
                return users[i].name;
            }
        }
        //return typeof name === "undefined" ? "Unknown" : name;
    }
    generateColors(users) {
        const { MessageColors } = this.state;

        let cols = MessageColors;
        for (let i = 0; i < users.length; i++)
            cols.push({
                color: `rgb(${this.genRandomNumber(
                    0,
                    255
                )},${this.genRandomNumber(0, 255)},${this.genRandomNumber(
                    0,
                    255
                )})`,
                uid: users[i],
            });

        this.setState({ MessageColors: cols });
    }
    getColor(uid) {
        const { MessageColors } = this.state;

        for (let i = 0; i < MessageColors.length; i++) {
            if (MessageColors[i].uid === uid) return MessageColors[i].color;
        }
    }
    genRandomNumber(min, max) {
        let random_number = Math.random() * (max - min) + min;
        return Math.floor(random_number);
    }
    renderTextDetail(label, key) {
        const { new_group } = this.state;
        const { classes } = this.props;

        return (
            <TextField
                key={key}
                value={new_group[key]}
                label={label}
                className={classes.textField}
                onChange={(val) => {
                    new_group[key] = val.target.value;
                    this.setState({ new_group });
                }}
            />
        );
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleViewMessageGroupModal = () => {
        this.setState({ viewGroupModal: true });
    };
    handleCloseMessageModal = () => {
        this.setState({ viewGroupModal: false });
        this.setState({ uploadPhotoLocal: false });
    };
    handleNewGroupModal = () => {
        this.setState({
            newGroupModal: true,
            new_group: {
                group_name: "",
                users_in_group: [],
                group_image: "",
            },
        });
    };

    handleCloseGroupModal = () => {
        this.setState({ uploadImageLocal: false });
        this.setState({ newGroupModal: false });
    };
    handleEditGroupModal = () => {
        this.setState({ editGroupModal: true });
        this.setState({ uploadImageLocal: false });
    };
    handleAddGroupModal = () => {
        this.setState({ addGroupModal: true });
    };
    handleCloseEditGroupModal = () => {
        this.setState({ editGroupModal: false });
        this.setState({ uploadImageLocal: false });
    };
    handleRemoveGroupModal = () => {
        this.setState({ removeGroupModal: true });
    };
    handleCloseRemoveGroupModal = () => {
        this.setState({ removeGroupModal: false });
    };
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: event.target.value });
    };
    onFormSubmit(group) {
        this.props.setNewGroup(group);
        this.handleCloseGroupModal();
        this.setState({ uploadImageLocal: false });
    }
    getInitials(name) {
        if (typeof name === "undefined") return "NA";

        let first = name.split(" ")[0][0];
        let last = name.split(" ")[name.split(" ").length - 1][0];
        return `${first}${last}`;
    }

    renderRequiredGroupDetails = () => {
        return (
            <div>
                <ModalBody>
                    <StyledAvatar
                        style={{}}
                        src={
                            this.state.uploadImageLocal
                                ? this.state.uploadImageLocal
                                : noImg
                        }
                        alt="Profile Image"
                    />
                    <div
                        style={{
                            marginLeft: 0,
                            position: "absolute",
                            bottom: 0,
                        }}
                    >
                        <Typography variant="body2">Add Group Image</Typography>
                    </div>
                </ModalBody>
                <ModalBody>
                    <input
                        type="file"
                        id="file"
                        accept="image/*"
                        ref="imageUploader"
                        style={{ display: "none" }}
                        onChange={(event) => {
                            if (event.target.files[0].size > 1000000) {
                                this.setState({ fileMaxSizeSnackbar: true });
                            } else {
                                let group = {
                                    ...this.state.new_group,
                                    group_image: event.target.files[0],
                                };
                                this.setState({
                                    new_group: group,
                                    uploadImageLocal: URL.createObjectURL(
                                        event.target.files[0]
                                    ),
                                });
                                // this.state.setGroupImgBlob(event.target.files[0]);
                            }
                        }}
                    />
                    <IconButton
                        onClick={() => {
                            this.refs.imageUploader.click();
                        }}
                        style={{
                            margin: "inherit",
                            color: "green",
                            border: "1px solid green",
                        }}
                    >
                        <AddIcon />
                    </IconButton>
                    <Typography style={{ margin: "inherit" }} variant="body2">
                        {"(< 1MB)"}
                    </Typography>
                </ModalBody>
            </div>
        );
    };
    render() {
        const users = this.props.users === [] ? false : this.props.users;
        const groups = this.props.groups === [] ? false : this.props.groups;
        const { profile } = this.props;
        const { new_group } = this.state;
        const { messages_in_group } = this.state;
        const { classes } = this.props;

        return (
            <StyledCard>
                <StyledHeader>
                    <Typography variant="h5" >Messenger Groups</Typography>
                </StyledHeader>
                <StyledContent>
                    <Modal
                        isOpen={this.props.requesting}
                        style={{ maxWidth: "00px" }}
                    >
                        <ModalBody>
                            {this.props.requesting && (
                                <div
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "3em",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "white",
                                            width: "fit-content",
                                            display: "inline-block",
                                            padding: "2em",
                                        }}
                                    >
                                        <Spinner
                                            style={{
                                                height: 100,
                                                width: 100,
                                                background: "white",
                                            }}
                                            color="primary"
                                        />
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                marginTop: 15,
                                                color: "rgba(0, 0, 0, 0.87)",
                                                fontWeight: "bolder",
                                                fontSize: 20,
                                            }}
                                            variant="body2"
                                        >
                                            Processing...
                                        </Typography>
                                    </div>
                                </div>
                            )}
                        </ModalBody>
                    </Modal>

                    <div className={classes.tableWrapper}>
                        <StyledViewContainer>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        {this.props.canCreate && (
                                            <Button
                                                onClick={() => {
                                                    let group = {
                                                        group_name: "",
                                                        users_in_group: [],
                                                        group_image: "",
                                                    };
                                                    this.setState({
                                                        new_group: group,
                                                    });

                                                    this.handleNewGroupModal();
                                                }}
                                           
                                                variant="h5" 
                                                style={{ background: "#0188cc" , color:"white"}}
                                            >
                                                Add New Group
                                            </Button>
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableHead>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="body2">
                                                <b>Group ID</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="body2">
                                                <b>Group Image</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="body2">
                                                <b>Group Name</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                <b>Users in Group</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                <b>Messages Sent</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                <b>Action</b>
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {groups.map((e, i) => {
                                        return (
                                            <TableRow key={i}>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    <Typography variant="body1">
                                                        {e.group_id}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    <div
                                                        style={{
                                                            height: "60px",
                                                            width: "60px",
                                                        }}
                                                    >
                                                        <Avatar
                                                            alt="group image"
                                                            src={e.group_image}
                                                            style={{
                                                                height: "100%",
                                                                width: "100%",
                                                                margin: "auto",
                                                            }}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    <Typography variant="body1">
                                                        {e.group_name}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {typeof e.users_in_group !==
                                                            "undefined"
                                                            ? e.users_in_group
                                                                .length
                                                            : 0}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {e.messages_in_group
                                                            ? Object.keys(
                                                                e.messages_in_group
                                                            ).length
                                                            : 0}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <IconButton
                                                        aria-label="Message"
                                                        onClick={() => {
                                                            this.setState({
                                                                colorsNo:
                                                                    e
                                                                        .users_in_group
                                                                        .length,
                                                            });

                                                            let messageArr = [];
                                                            e.messages_in_group &&
                                                                Object.keys(
                                                                    e.messages_in_group
                                                                ).map((f) => {
                                                                    messageArr.push(
                                                                        e
                                                                            .messages_in_group[
                                                                        f
                                                                        ]
                                                                    );
                                                                    return f;
                                                                });
                                                            let sortedSelectedReports = messageArr.sort(
                                                                (a, b) => {
                                                                    a = new moment(
                                                                        a.timestamp,
                                                                        "DD-MM-YYYY hh:mm:ss"
                                                                    ); //.format("DD/MM/YYYY hh:mm:ss");
                                                                    b = new moment(
                                                                        b.timestamp,
                                                                        "DD-MM-YYYY hh:mm:ss"
                                                                    ); //.format("DD/MM/YYYY hh:mm:ss");
                                                                    return a.diff(
                                                                        b
                                                                    );
                                                                }
                                                            );

                                                            let messages = sortedSelectedReports.reverse();
                                                            this.generateColors(
                                                                e.users_in_group
                                                            );
                                                            this.setState({
                                                                viewMessages: {
                                                                    id:
                                                                        e.group_id,
                                                                    messages,
                                                                },
                                                            });
                                                            this.setState({
                                                                addUID:
                                                                    e.group_id,
                                                            });
                                                            this.handleViewMessageGroupModal();
                                                        }}
                                                    >
                                                        <MessageIcon />
                                                    </IconButton>
                                                    {this.props.canUpdate && (
                                                        <IconButton
                                                            aria-label="Edit"
                                                            onClick={() => {
                                                                this.setState({
                                                                    editUID:
                                                                        e.group_id,
                                                                    new_group: e,
                                                                });
                                                                this.handleEditGroupModal();
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    )}
                                                    {this.props.canDelete && (
                                                        <IconButton
                                                            aria-label="Delete"
                                                            onClick={() => {
                                                                this.setState({
                                                                    removeUID:
                                                                        e.group_id,
                                                                });
                                                                this.handleRemoveGroupModal();
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    )}
                                                    {/* {
                                                        <IconButton
                                                            arial-label="Add"
                                                            onClick={() => {
                                                                this.setState({
                                                                    addUID: e.group_id
                                                                })
                                                                this.handleAddGroupModal();
                                                            }}

                                                        >
                                                            <AddIcon />
                                                        </IconButton>
                                                    } */}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </StyledViewContainer>
                    </div>
                    {/* <div>
                        <Modal isOpen={this.state.addGroupModal} >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Add Messages
                            </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <Col>
                                   
                                        <TextField
                                            // key={key}
                                            // value={messages_in_group["message"]}
                                            label={"message"}
                                            className={classes.textField}
                                            onChange={val => {
                                                let date = new Date();
                                                messages_in_group["message"] = val.target.value;
                                                messages_in_group["sender"]= profile.uid
                                                messages_in_group["timestamp"]= moment(date).format("DD-MM-YYYY hh:mm:ss");
                                                this.setState({ messages_in_group });
                                            }}
                                        />
                                              <StyledAvatar
                                        style={{}}
                                        src={
                                            this.state.uploadPhotoLocal
                                                ? this.state.uploadPhotoLocal
                                                : this.state.messages_in_group.attatched_image_url
                                        }
                                        alt="Profile Image"
                                    />
                                    <div
                                        style={{
                                            marginLeft: 0,
                                            position: "absolute",
                                            bottom: 0
                                        }}
                                    >
                                        <Typography variant="body2">
                                            Attach Image
                                </Typography>
                                    </div>
                                               <input
                                        type="file"
                                        id="file"
                                        accept="image/*"
                                        ref="photoUploader"
                                        style={{ display: "none" }}
                                        onChange={event => {
                                            if (event.target.files[0].size > 1000000) {
                                                this.setState({ "fileMaxSizeSnackbar": true });
                                            }
                                            else {
                                                let messages_in_group = {
                                                    ...this.state.messages_in_group,
                                                    attatched_image_url: event.target.files[0]
                                                };
                                                this.setState({
                                                    messages_in_group: messages_in_group,
                                                    uploadPhotoLocal: URL.createObjectURL(event.target.files[0])
                                                });
                                            }
                                        }}

                                    />
                                    <IconButton
                                        onClick={() => {
                                            this.refs.photoUploader.click();
                                        }}
                                        style={{
                                            margin: "inherit",
                                            color: "green",
                                            border: "1px solid green"
                                        }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                    <Typography
                                        style={{ margin: "inherit" }}
                                        variant="body2"
                                    >
                                        {"(< 1MB)"}
                                    </Typography>
                                    </Col>
                                </ModalBody>
                                <ModalFooter>
                                    <IconButton
                                        disabled = {!this.state.messages_in_group.message}
                                        onClick={()=>{
                                            this.props.addMessages(this.state.addUID,messages_in_group)
                                            this.setState({  messages_in_group: {
                                                message: "",
                                                sender: "",
                                                timestamp: "",
                                                attatched_image_url: ""
                                            }})
                                            this.setState({addGroupModal:false,uploadPhotoLocal:false})
                                        }} 
                                    >
                                       <SendIcon/>
                                       </IconButton>
                                  
                                    <Button onClick={() => {
                                           this.setState({  messages_in_group: {
                                            message: "",
                                            sender: "",
                                            timestamp: "",
                                            attatched_image_url: ""
                                        }})
                                        this.setState({addGroupModal:false,uploadPhotoLocal:false})
                                    }}>
                                        Cancel
                                    </Button>
                                </ModalFooter>
                            </StyledContent>
                        </Modal>
                    </div> */}
                    <div>
                        <Modal
                            isOpen={this.state.editGroupModal}
                            className={classes.addUserModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Edit Message Group
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <Row>
                                        <Col>
                                            {" "}
                                            {this.renderTextDetail(
                                                "Group Name",
                                                "group_name"
                                            )}
                                        </Col>
                                        <Col>
                                            <br></br>
                                            <FormControl
                                                className={classes.form}
                                            >
                                                <InputLabel>
                                                    Users Included
                                                </InputLabel>
                                                <Select
                                                    multiple={true}
                                                    value={
                                                        this.state.new_group
                                                            .users_in_group
                                                    }
                                                    onChange={(event) => {
                                                        // let newGroup = this.state.new_group;
                                                        let newGroup = {
                                                            ...this.state
                                                                .new_group,
                                                            group_image: this
                                                                .state.new_group
                                                                .group_image,
                                                        };
                                                        newGroup.users_in_group =
                                                            event.target.value;
                                                        this.setState({
                                                            new_group: newGroup,
                                                            uploadImageLocal: this
                                                                .state.new_group
                                                                .group_image,
                                                        });
                                                    }}
                                                >
                                                    {users &&
                                                        users.map((e, i) => {
                                                            return (
                                                                <MenuItem
                                                                    key={i}
                                                                    value={
                                                                        e.uid
                                                                    }
                                                                >
                                                                    {e.name}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                </Select>
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </ModalBody>
                                <br />
                                <ModalBody>
                                    <StyledAvatar
                                        style={{}}
                                        src={
                                            this.state.uploadImageLocal
                                                ? this.state.uploadImageLocal
                                                : this.state.new_group
                                                    .group_image
                                        }
                                        alt="Profile Image"
                                    />
                                    <div
                                        style={{
                                            marginLeft: 0,
                                            position: "absolute",
                                            bottom: 0,
                                        }}
                                    >
                                        <Typography variant="body2">
                                            Edit Group Image
                                        </Typography>
                                    </div>
                                </ModalBody>
                                <ModalBody>
                                    <input
                                        type="file"
                                        id="file"
                                        accept="image/*"
                                        ref="imageUploader"
                                        style={{ display: "none" }}
                                        onChange={(event) => {
                                            if (
                                                event.target.files[0].size >
                                                1000000
                                            ) {
                                                this.setState({
                                                    fileMaxSizeSnackbar: true,
                                                });
                                            } else {
                                                let group = {
                                                    ...this.state.new_group,
                                                    group_image:
                                                        event.target.files[0],
                                                };
                                                this.setState({
                                                    new_group: group,
                                                    uploadImageLocal: URL.createObjectURL(
                                                        event.target.files[0]
                                                    ),
                                                });
                                                // this.state.setGroupImgBlob(event.target.files[0]);
                                            }
                                        }}
                                    />
                                    <IconButton
                                        onClick={() => {
                                            this.refs.imageUploader.click();
                                        }}
                                        style={{
                                            margin: "inherit",
                                            color: "green",
                                            border: "1px solid green",
                                        }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                    <Typography
                                        style={{ margin: "inherit" }}
                                        variant="body2"
                                    >
                                        {"(< 1MB)"}
                                    </Typography>
                                </ModalBody>
                            </StyledContent>
                            {/* <StyledContent> */}
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={this.handleCloseEditGroupModal}
                                        className={classes.backButton}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.props.editGroup(new_group);
                                            this.props.editGroupImage(
                                                new_group
                                            );
                                            this.handleCloseEditGroupModal();

                                            // onClick={() => this.onFormSubmit(new_group)}
                                        }}
                                        disabled={
                                            new_group.users_in_group.length === 0
                                                ? true
                                                : false
                                        }
                                    >
                                        Edit Group
                                    </Button>
                                </div>
                            </ModalFooter>
                            {/* </StyledContent> */}
                        </Modal>
                    </div>
                    <div>
                        <Modal
                            isOpen={this.state.viewGroupModal}
                            className={classes.addUserModal}
                        >
                            {/* <ModalHeader>Groups Messages</ModalHeader> */}
                            <ModalHeader>
                                {" "}
                                Group Messages
                                <Button
                                    
                                    variant="h5"
                                    style={{ background: "#0188cc",color:"white",marginLeft: "190px" }}
                                    onClick={this.handleCloseMessageModal}
                                    className={classes.backButton}
                                >
                                    Cancel
                                </Button>
                            </ModalHeader>
                            <StyledContent>
                                <ModalBody>
                                    <List className={classes.MessageList}>
                                        {this.state.viewMessages &&
                                            Object.keys(
                                                this.state.viewMessages.messages
                                            ).map((e) => {
                                                return (
                                                    <ListItem
                                                        className={
                                                            classes.MessageItem
                                                        }
                                                        alignItems="flex-start"
                                                    >
                                                        <ListItemAvatar>
                                                            <Avatar
                                                                style={{
                                                                    backgroundColor: `${this.getColor(
                                                                        this
                                                                            .state
                                                                            .viewMessages
                                                                            .messages[
                                                                            e
                                                                        ].sender
                                                                    )}`,
                                                                }}
                                                            >
                                                                {" "}
                                                                {this.getInitials(
                                                                    this.getNameofUser(
                                                                        this
                                                                            .state
                                                                            .viewMessages
                                                                            .messages[
                                                                            e
                                                                        ].sender
                                                                    )
                                                                )}{" "}
                                                            </Avatar>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={this.getNameofUser(
                                                                this.state
                                                                    .viewMessages
                                                                    .messages[e]
                                                                    .sender
                                                            )}
                                                            secondary={
                                                                <React.Fragment>
                                                                    {this.state
                                                                        .viewMessages
                                                                        .messages[
                                                                        e
                                                                    ]
                                                                        .attatched_image_url && (
                                                                            <img
                                                                                style={{
                                                                                    position:
                                                                                        "relative",
                                                                                    width:
                                                                                        "90%",
                                                                                    margin: 12,
                                                                                    height:
                                                                                        "auto",
                                                                                }}
                                                                                src={
                                                                                    this
                                                                                        .state
                                                                                        .viewMessages
                                                                                        .messages[
                                                                                        e
                                                                                    ]
                                                                                        .attatched_image_url
                                                                                }
                                                                                alt="attachment"
                                                                            />
                                                                        )}
                                                                    <div
                                                                        style={{
                                                                            overflowWrap:
                                                                                "break-word",
                                                                        }}
                                                                    >
                                                                        {
                                                                            this
                                                                                .state
                                                                                .viewMessages
                                                                                .messages[
                                                                                e
                                                                            ]
                                                                                .message
                                                                        }
                                                                        <br />
                                                                        {
                                                                            this
                                                                                .state
                                                                                .viewMessages
                                                                                .messages[
                                                                                e
                                                                            ]
                                                                                .timestamp
                                                                        }
                                                                    </div>
                                                                </React.Fragment>
                                                            }
                                                        />
                                                    </ListItem>
                                                );
                                            })}
                                    </List>
                                </ModalBody>
                            </StyledContent>
                            {/* <StyledContent> */}
                            <ModalFooter>
                                <TextField
                                    // key={key}
                                    value={messages_in_group["message"]}
                                    style={{ width: "400px" }}
                                    label={"Enter your Message here"}
                                    className={classes.textField}
                                    onChange={(val) => {
                                        let msg = messages_in_group;
                                        msg["message"] = val.target.value;

                                        this.setState({
                                            messages_in_group: msg,
                                        });
                                    }}
                                />

                                <div>
                                    <IconButton
                                        style={{ color: "#0188cc" }}
                                        onClick={() => {
                                            let msg = messages_in_group;
                                            msg["sender"] = profile.uid;
                                            msg["timestamp"] = moment().format(
                                                "DD-MM-YYYY HH:mm:ss"
                                            );
                                            this.setState({
                                                messages_in_group,
                                            });
                                            this.props.addMessages(
                                                this.state.addUID,
                                                msg
                                            );
                                            this.setState({
                                                messages_in_group: {
                                                    message: "",
                                                    sender: "",
                                                    timestamp: "",
                                                    attatched_image_url: null,
                                                },
                                            });
                                            this.setState({
                                                addGroupModal: false,
                                                uploadPhotoLocal: false,
                                            });
                                        }}
                                    >
                                        <SendIcon />
                                    </IconButton>
                                </div>
                                <input
                                    type="file"
                                    id="file"
                                    accept="image/*"
                                    ref="photoUploader"
                                    style={{ display: "none" }}
                                    onChange={(event) => {
                                        if (
                                            event.target.files[0].size > 1000000
                                        ) {
                                            this.setState({
                                                fileMaxSizeSnackbar: true,
                                            });
                                        } else {
                                            let messages_in_group = {
                                                ...this.state.messages_in_group,
                                                attatched_image_url:
                                                    event.target.files[0],
                                            };
                                            this.setState({
                                                messages_in_group: messages_in_group,
                                                uploadPhotoLocal: URL.createObjectURL(
                                                    event.target.files[0]
                                                ),
                                            });
                                        }
                                    }}
                                />
                                <AddBoxIcon
                                    onClick={() => {
                                        this.refs.photoUploader.click();
                                    }}
                                    style={{
                                        margin: "inherit",
                                        color: "#0188cc",
                                        height: "44px",
                                        width: "50px",
                                    }}
                                ></AddBoxIcon>
                                {/* <Typography
                                style={{ margin: "inherit" }}
                                variant="body2"
                            >
                                {"< 1MB"}
                            </Typography> */}
                            </ModalFooter>
                            <div>
                                {this.state.uploadPhotoLocal ? (
                                    <>
                                        <Avatar
                                            style={{
                                                padding: "7px",
                                                borderRadius: "32px",
                                                width: 100,
                                                height: 100,
                                                marginLeft: "8px",
                                            }}
                                            variant="rounded"
                                            src={
                                                this.state.uploadPhotoLocal
                                                    ? this.state
                                                        .uploadPhotoLocal
                                                    : noImg
                                            }
                                            alt="Icon Image"
                                        />
                                    </>
                                ) : (
                                        ""
                                    )}
                            </div>

                            {/* </StyledContent> */}
                        </Modal>
                    </div>
                    <div>
                        <Modal
                            isOpen={this.state.newGroupModal}
                            className={classes.addUserModal}
                        >
                            <StyledHeader style={{ background: "#0188cc" }}>
                                <Typography variant="h5" style={{ color: "white" }}>
                                    Add New Group
                                </Typography>
                            </StyledHeader>

                            {/* <ModalHeader>Add New Group</ModalHeader>          */}
                            <StyledContent>
                                <ModalBody>
                                    <Row>
                                        <Col>
                                            {" "}
                                            {this.renderTextDetail(
                                                "Group Name",
                                                "group_name"
                                            )}
                                        </Col>
                                        <Col>
                                            <FormControl
                                                className={classes.form}
                                                required
                                            >
                                                <InputLabel>
                                                    Users Included
                                                </InputLabel>
                                                <Select
                                                    multiple={true}
                                                    value={
                                                        this.state.new_group
                                                            .users_in_group
                                                    }
                                                    onChange={(event) => {
                                                        let newGroup = this
                                                            .state.new_group;
                                                        newGroup.users_in_group =
                                                            event.target.value;
                                                        this.setState({
                                                            new_group: newGroup,
                                                        });
                                                    }}
                                                >
                                                    {users &&
                                                        users.map((e, i) => {
                                                            return (
                                                                <MenuItem
                                                                    key={i}
                                                                    value={
                                                                        e.uid
                                                                    }
                                                                >
                                                                    {e.name}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                </Select>

                                                <FormHelperText
                                                    style={{ color: "red" }}
                                                >
                                                    Required
                                                </FormHelperText>
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </ModalBody>
                                {this.renderRequiredGroupDetails()}
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={this.handleCloseGroupModal}
                                        className={classes.backButton}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="h5"
                                        style={{ background: "#0188cc",color:"white" }}
                                        onClick={() =>
                                            this.onFormSubmit(new_group)
                                        }
                                        disabled={
                                            new_group.users_in_group.length === 0
                                                ? true
                                                : false
                                        }
                                    >
                                        Add Group
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    <div>
                        <Modal
                            isOpen={this.state.removeGroupModal}
                            className={classes.addUserModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Remove Group
                                </Typography>
                            </StyledHeader>
                            {/* <ModalHeader>Remove Group</ModalHeader> */}
                            <StyledContent>
                                <ModalBody>
                                    <Typography variant="body2">
                                        Are you you sure you want to remove this
                                        Group? <br /> You will lose any
                                        conversation had in this group.
                                    </Typography>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={
                                            this.handleCloseRemoveGroupModal
                                        }
                                        className={classes.backButton}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.props.removeGroup(
                                                this.state.removeUID
                                            );
                                            this.handleCloseRemoveGroupModal();
                                        }}
                                    >
                                        Remove
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                </StyledContent>
            </StyledCard>
        );
    }
}

export default connect(
    (store) => {
        return {
            users: selectRegisteredUsers(store),
            groups: selectGroup(store),
            requesting: getRequesting(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
            profile: selectProfile(store),
        };
    },
    {
        getRegisteredUsers,
        setNewGroup,
        getGroups,
        removeGroup,
        editGroup,
        editGroupImage,
        addMessages,
        getAreas, 
        getDepartments
    }
)(withStyles(styles)(Messenger));
